import Card from "../components/Card";
import useService from "../hooks/useServices";

const Products = () => {
  const { service } = useService({ type: "highlights" });

  return (
    <div className="px-8 py-24 flex justify-between">
      <Card item={{ ...service[0], type: "kitchens" }} />
      <Card item={{ ...service[1], type: "kitchens" }} />
      <Card item={{ ...service[2], type: "kitchens" }} />
    </div>
  );
};

export default Products;
